import React from 'react';
export const context = { tiles: React.createContext({}) };

export default context;
